export interface CircleProps {
  cx: number;
  cy: number;
  r: number;
}

export interface RectProps {
  height: number;
  width: number;
  x: number;
  y: number;
}
